import { FormControl } from '@angular/forms';

export enum MCGRNewRequestSettlementScopeControlName {
  Scope = 'scope',
  Amount = 'amount',
  PercentageShare = 'percentageShare',
}

export interface MCGRSettlementScopeFormGroup {
  [MCGRNewRequestSettlementScopeControlName.Scope]: FormControl<string>;
  [MCGRNewRequestSettlementScopeControlName.Amount]: FormControl<number>;
  [MCGRNewRequestSettlementScopeControlName.PercentageShare]: FormControl<number>;
}

export interface SettlementScope {
  [MCGRNewRequestSettlementScopeControlName.Scope]: string;
  [MCGRNewRequestSettlementScopeControlName.Amount]?: number;
  [MCGRNewRequestSettlementScopeControlName.PercentageShare]?: number;
}

export class SettlementScopeDto {
  constructor(
    public ZakresRzeczowy: string,
    public Kwota?: number,
    public UdzialProcent?: number,
  ) {}

  static fromAppToApi(data: SettlementScope): SettlementScopeDto {
    return new this(data.scope, data.amount, data.percentageShare);
  }
}
